import { TAdminData, EAdminRole } from 'views/types/admins';

interface Role {
  id: string;
  name: string;
  description: string;
}

export const useAdminPermissions = () => {
  const canEditAdmin = (
    targetAdmin: TAdminData | null,
    currentAdmin: TAdminData | null
  ) => {
    if (!targetAdmin || !currentAdmin) return false;

    if (currentAdmin.role === EAdminRole.SUPER_ADMIN) return true;

    if (currentAdmin.role === EAdminRole.ADMIN) {
      return (
        targetAdmin.role !== EAdminRole.SUPER_ADMIN &&
        targetAdmin.role !== EAdminRole.ADMIN
      );
    }

    return (
      targetAdmin.role !== EAdminRole.SUPER_ADMIN &&
      targetAdmin.role !== EAdminRole.ADMIN
    );
  };

  const getAvailableRoles = (currentUserRole: string, allRoles: Role[]) => {
    if (!allRoles.length) return [];

    switch (currentUserRole) {
      case EAdminRole.SUPER_ADMIN:
        return allRoles;
      case EAdminRole.ADMIN:
        return allRoles.filter(
          role =>
            role.name !== EAdminRole.SUPER_ADMIN &&
            role.name !== EAdminRole.ADMIN
        );
      default:
        return [];
    }
  };

  const canAssignRole = (
    roleName: string,
    currentUserRole: string,
    allRoles: Role[]
  ) => {
    const availableRoles = getAvailableRoles(currentUserRole, allRoles);
    return availableRoles.some(role => role.name === roleName);
  };

  return {
    canEditAdmin,
    getAvailableRoles,
    canAssignRole,
  };
};
